<template>
  <div class="w-full flex flex-col gap-1" style="max-width: 400px" ref="main">
    <q-tabs v-model="tab" class="text-teal" dense v-if="$route.query.asset">
      <q-tab name="profile" label="Vehicle Profile" />
      <q-tab name="remarks" label="Remarks" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel
        name="profile"
        class="w-full flex flex-col gap-1"
        v-if="renderProfile"
      >
        <FormInput
          v-for="(item, i) in ui"
          :key="i"
          :data="item"
          v-model="store.state.profile[item.model]"
        />
      </q-tab-panel>
      <q-tab-panel name="remarks">
        <div>Remarks</div>

        <textarea
          v-model="store.state.profile.remarks"
          style="height: 100px; max-height: 70px"
          class="w-full p-2"
        />
        <div class="mt-2">Upload Recent Images</div>
        <div style="width: 100%; height: 100px" class="flex gap-4">
          <uploader
            style="border: 1.5px dashed #00000066"
            class="flex-1 rounded flex flex-center p-2 text-sm text-center cursor-pointer uploader duration-500"
            @success="updateProfile"
          >
            Drop your file here to upload
          </uploader>
          <div
            class="w-1/2 flex flex-col flex-no-wrap gap-1 overflow-auto"
            style="max-height: 100%"
          >
            <div
              v-for="(file, i) in files"
              class="w-full flex flex-shrink-0 rounded overflow-hidden"
              style="border: solid 1px rgb(234, 234, 234)"
            >
              <q-avatar size="40px" square>
                <a
                  :href="`https://api.igeotechgps.com/uploads/${file.link}`"
                  target="_blank"
                  class="fit"
                >
                  <img
                    v-if="images.includes(file.type)"
                    :src="`https://api.igeotechgps.com/uploads/${file.link}`"
                    :alt="file.name" />
                  <div
                    v-else
                    class="fit flex flex-center items-center"
                    style="
                      border-right: solid 1px rgb(234, 234, 234);
                      background: #e5f1ff;
                    "
                  >
                    <q-icon
                      name="insert_drive_file"
                      color="primary"
                      size="25px"
                    /></div
                ></a>
              </q-avatar>
              <div class="flex-1 h-full flex flex-col p-2 justify-center">
                <div style="font-size: 8px">{{ file.name }}</div>
              </div>
              <q-separator inset vertical />
              <div class="flex flex-center px-1">
                <q-btn
                  color="danger"
                  icon="delete"
                  flat
                  padding="none"
                  size="10px"
                  @click="removeDocument(i)"
                />
              </div>
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script setup>
import { computed, watch, ref } from 'vue';

import { useRoute, useRouter } from 'vue-router/composables';

import { store } from '../../api/api';
import { brand } from '../../cars-brand';
import { getBaseURL } from '@/config.js';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import FormInput from '../components/FormInput.vue';
import Uploader from '../components/Uploader.vue';

const route = useRoute();
const main = ref();
async function updateProfile(v) {
  // console.log(route.query.asset);
  if (!store.state.profile.vehicleImages) {
    store.state.profile.vehicleImages = [];
  }
  store.state.profile.vehicleImages.push(v);
  await store.updateData(route.query.asset, main.value);
}
async function removeDocument(i) {
  store.state.profile.vehicleImages.splice(i, 1);
  await store.updateData(route.query.asset, main.value);
}

const props = defineProps({
  data: { default: null },
  readonly: { default: false },
  quickView: { default: false },
});

const tab = ref('profile');

const ui = ref([
  { label: 'Plate No.', model: 'plate', input: true, readonly: true },
  {
    label: 'Vehicle Type',
    model: 'type',
    options: [
      'CAR',
      'BOAT',
      'BUS',
      'LORRY/TRUCK',
      '4WD/PICKUP TRUCK',
      'MACHINERY',
      'MOTORCYCLE',
    ],
  },
  {
    label: 'Vehicle Sub Type',
    model: 'subType',
    options: [],
  },
  { label: 'Brand', model: 'brand', options: brand },
  { label: 'Model', model: 'model', input: true },
  {
    label: 'Industry',
    model: 'industry',
    multiple: true,
    options: [
      'Personal Usage',
      'Agriculture & Farm Product',
      'Construction',
      'Container Handling',
      'Container Haulage',
      'Courier',
      'Drilling Rig Machine',
      'Food Distribution',
      'General Cargo',
      'Manufacturing Raw Materials',
      'Milling Machine',
      'Palm Oil',
      'Pavers',
      'Petro Chemical Tankers',
      'Road Roller',
      'Skid Steer Roller',
      'Stacker',
      'Tractor',
      'Tractor Back Pusher',
      'Utility & Public Services',
    ],
  },
  {
    label: 'Toll class',
    model: 'class',
    options: [
      'Class 1 (Motorcycles)',
      'Class 2 (Car/3 wheels commercial vehicle)',
      'Class 3 (Lorry & Van with 2 axles & 4 wheels / Bus with 2 axles & 4 wheels)',
      'Class 4 (Lorry & Van with 2 axles & 5/6 wheels / Bus with 2 axles & 5/6 wheels)',
      'Class 5 (Vehicle with 3 axles / Bus with 3 axles)',
      'Class 6 (Vehicle with 4 axles)',
      'Class 7 (Vehicle with 5 or more axles)',
    ],
  },
]);

const renderProfile = ref(true);
watch(
  () => store.state.profile.type,
  () => {
    if (store.state && store.state.profile && store.state.profile.type) {
      // console.log(ui.value[2].options, subtypes[store.state.profile.type]);
      ui.value[2].options = subtypes[store.state.profile.type];
      store.state.profile = {
        ...store.state.profile,
        subType: subtypes[store.state.profile.type][0],
      };

      setTimeout(() => {
        renderProfile.value = false;
      }, 0);
      setTimeout(() => {
        renderProfile.value = true;
      }, 1);
    } else {
      ui.value[2].options = [];
    }
  },
  { immediate: true },
);

const subtypes = {
  BOAT: ['BOAT'],
  BUS: ['BUS'],
  CAR: [
    'SUV',
    'Hatchback',
    'Crossover',
    'Convertible',
    'Sedan',
    'Sports Car',
    'Van',
  ],
  'LORRY/TRUCK': [
    '1 tonne',
    '3 / 5 tonne',
    '10 Tonne (Cargo Truck)',
    '10 Tonne Tipper / Crane - 1',
    '20 Tonne Tipper / Crane - 1',
    'Ready Mix',
    'Prime Movers - 1',
    'Prime Movers - 2',
  ],
  '4WD/PICKUP TRUCK': ['Light Duty', 'Heavy Duty', 'Chassis', 'Hybrid'],
  MOTORCYCLE: [
    'Standard',
    'Cruiser',
    'Sport Bike',
    'Touring',
    'Sport Touring',
    'Dual Sport',
    'Scooter',
    'Moped',
    'Off-road',
  ],
  MACHINERY: [
    'Backhoe Loaders',
    'Excavators',
    'Loader',
    'Bulldozers',
    'Skid Steel Loaders',
    'Shovels',
    'Motor Graders',
    'Motor Scrapers',
    'Dump Truck',
    'Dragline',
    'Trenchers',
    'Forklift',
  ],
};

const remarks = ref('');
const dropzoneOptions = {
          url: getBaseURL() + '/fleets/uploadFiles',
  thumbnailWidth: 150,
  maxFilesize: 10.0,
  maxFiles: 15,
  addRemoveLinks: true,
  //autoProcessQueue: false
};

const files = computed(() => {
  let arr = [];
  if (store.state.profile.vehicleImages) {
    store.state.profile.vehicleImages.forEach((e) => {
      arr.push(getFileName(e));
    });
  }
  return arr;
});
function getFileName(str) {
  let arr = str.split('_');
  return {
    name: arr.slice(3).join(''),
    type: arr.at(-1).split('.')[1],
    link: str,
  };
}
const images = ['jpg', 'jpeg', 'png', 'svg'];
</script>

<style scoped>
.uploader:hover {
  background: #f1f1f1;
}
</style>
